var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Upload-2",
    "data-name": "Upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480,136H464V112a24.027,24.027,0,0,0-24-24H234.806L197,57.753A8,8,0,0,0,192,56H72A24.027,24.027,0,0,0,48,80v56H32A24.027,24.027,0,0,0,8,160V432a24.027,24.027,0,0,0,24,24H480a24.027,24.027,0,0,0,24-24V160A24.027,24.027,0,0,0,480,136ZM64,80a8.009,8.009,0,0,1,8-8H189.194L227,102.247A8,8,0,0,0,232,104H440a8.009,8.009,0,0,1,8,8v24H64ZM488,432a8.009,8.009,0,0,1-8,8H32a8.009,8.009,0,0,1-8-8V160a8.009,8.009,0,0,1,8-8H480a8.009,8.009,0,0,1,8,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,416H40a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,416h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,200a96,96,0,1,0,96,96A96.108,96.108,0,0,0,256,200Zm0,176a80,80,0,1,1,80-80A80.091,80.091,0,0,1,256,376Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.657,234.343a8,8,0,0,0-11.314,0l-48,48A8,8,0,0,0,208,296h16v40a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8V296h16a8,8,0,0,0,5.657-13.657ZM280,280a8,8,0,0,0-8,8v40H240V288a8,8,0,0,0-8-8h-4.687L256,251.313,284.687,280Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8af6c33e9d1cb9dadde12880ad3bc13d.svg";
export { ForwardRef as ReactComponent };